import axios from "axios";

// Base URLs
const MANAGEMENT_CONSOLE_BASE_URL = "https://api-stage.synnexb2b.com.au/qa";
const USER_BASE_URL = "https://api-stage.synnexb2b.com.au/qa";
const CMS_BASE_URL = "https://api-stage.synnexb2b.com.au/";

// Create API instances
const api = axios.create({
  baseURL: MANAGEMENT_CONSOLE_BASE_URL,
});

const userApi = axios.create({
  baseURL: USER_BASE_URL,
});

const cmsApi = axios.create({
  baseURL: CMS_BASE_URL,
});

// Function to add 503 error handling to any API instance
const setup503Handler = (axiosInstance, setMaintenanceActive) => {
  axiosInstance.interceptors.response.use(
    response => response,
    // response => {
    //   if (response.status === 200) {
    //     console.log("TEST MODE: Triggering maintenance mode on 200 response");
    //     if (setMaintenanceActive && typeof setMaintenanceActive === 'function') {
    //       console.log("success code handled");
    //       setMaintenanceActive(true);
    //     }
    //   }
    //   return response;
    // },
    error => {
      if (error?.status == 503 || error?.response?.status == 503) {
        // Call the setMaintenanceActive function from context if it exists
       console.log("TEST MODE: Triggering maintenance mode on 400 error code"); 
        if (setMaintenanceActive && typeof setMaintenanceActive === 'function') {
          setMaintenanceActive(true);
          return Promise.resolve({
            data: null,
            status: 503,
            handled: true,
            maintenance: true
          });
        }
      }
      return Promise.reject(error);
    }
  );
};

// This function will be called when the MaintenanceContext is initialized
export const setupMaintenanceHandling = (setMaintenanceActive) => {
  console.log(setMaintenanceActive, "setMaintenanceActive");
  // Set up handlers for all API instances
  setup503Handler(api, setMaintenanceActive);
  setup503Handler(userApi, setMaintenanceActive);
  // setup503Handler(cmsApi, setMaintenanceActive);
};

export { api, userApi, cmsApi };